import { iPodMenu, FocusWithin, State } from './Menu';

FocusWithin(document);

new State({
    header: '.header',
    namespace: 'main-nav',
});

new iPodMenu({
    namespace: 'ipod-nav',
    header: 'header',
    hamburger: 'header__hamburger',
});
